import ServerAPI from "@/services/ServerApi";

export default {
  getUser() {
    return ServerAPI.get("auth0/user", { withCredentials: true });
  },
  getUserGroups() {
    return ServerAPI.get("auth0/user-groups", { withCredentials: true });
  },
};
